<template>
  <div class="sub-menu-wrapper">
    <v-list>
      <v-list-tile @click.stop.prevent="backToMenu" class="menu_close">
        <v-list-tile-action> <v-icon>chevron_left</v-icon> </v-list-tile-action>
        <v-list-tile-title><v-icon v-html="item.icon"></v-icon> {{ item.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list>

    <h5 class="menu-item white--text text-center" v-text="AppState.currentProject.title"></h5>
    <div class="menu-item">
      <v-text-field label="Firebase Config" multi-line :value="AppState.currentProject.firebaseConfig || null" @blur="updateFirebase($event)"></v-text-field>
    </div>
  </div>
</template>

<script>
import fixJson from "durable-json-lint";
import AppState from "../util/AppState";
import { isJson } from "../util/utilities";
import { dbProjects } from "../firebase";

export default {
  props: ["item"],
  data() {
    return {
      AppState
    };
  },
  methods: {
    backToMenu() {
      this.$emit("backToMenu");
    },
    updateFirebase(ev) {
      if (ev.target.value.length > 2) {
        this.AppState.loading = true;
        const json = fixJson(ev.target.value).json;
        if (isJson(json)) {
          dbProjects
            .doc(AppState.currentProjectID)
            .update({
              firebaseConfig: json
            })
            .then(() => {
              this.AppState.loading = false;
            })
            .catch(error => {
              this.AppState.loading = false;
              this.AppState.error.text = error;
              this.AppState.error.show = true;
            });
        } else {
          this.AppState.loading = false;
          this.AppState.error.text =
            "Firebase config is not a valid JSON object.";
          this.AppState.error.show = true;
        }
      }
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MenuSettings.vue